import Axios from "axios";
import { BASE_HOST } from "@/config/config";

const axiosExtra = {
  setBaseURL(baseURL) {
    this.defaults.baseURL = baseURL;
  },
  setHeader(name, value, scopes = "common") {
    for (let scope of Array.isArray(scopes) ? scopes : [scopes]) {
      if (!value) {
        delete this.defaults.headers[scope][name];
        return;
      }
      this.defaults.headers[scope][name] = value;
    }
  },
  setToken(token, type, scopes = "common") {
    const value = !token ? null : (type ? type + " " : "") + token;
    this.setHeader("Authorization", value, scopes);
  },
  onRequest(fn) {
    console.error("请求出错：");
    this.interceptors.request.use(config => fn(config) || config);
  },
  onResponse(fn) {
    console.error("请求出错：");
    this.interceptors.response.use(response => fn(response) || response);
  },
  onRequestError(fn) {
    this.interceptors.request.use(
      undefined,
      error => fn(error) || Promise.reject(error)
    );
  },
  onResponseError(fn) {
    this.interceptors.response.use(undefined, error => {
      if (error.response && error.response.status === 401) {
        // 处理状态码为 401 的错误
        console.error("请求出错：", error.response);
        if (localStorage.getItem("mp_refreshToken")) {
          axios
            .post(`${BASE_HOST}/api/v1/auth/token/refresh`, {
              refreshToken: localStorage.getItem("mp_refreshToken")
            })
            .then(response => {
              console.log("Tokenres", response.data);
              localStorage.setItem(
                "mp_accessToken",
                response.data.data.accessToken
              );
              localStorage.setItem(
                "mp_refreshToken",
                response.data.data.refreshToken
              );
            })
            .catch(refreshError => {
              localStorage.setItem("mp_refreshToken", null);
              let lang = localStorage.getItem("mp_lang");
              localStorage.clear();
              localStorage.setItem("mp_lang", lang);
              window.history.go(0);
            });
        } else {
          let lang = localStorage.getItem("mp_lang");
          localStorage.clear();
          localStorage.setItem("mp_lang", lang);
          window.history.go(0);
        }
      } else {
        // 处理其他类型的错误
        console.error("请求出错：", error.message);
      }
      return fn(error) || Promise.reject(error);
    });
  },
  onError(fn) {
    this.onRequestError(fn);
    this.onResponseError(fn);
  }
};

const extendAxiosInstance = axios => {
  for (let key in axiosExtra) {
    axios[key] = axiosExtra[key].bind(axios);
  }
};

const axios = Axios.create();
function refreshToken() {
  // 执行刷新 token 的操作，并将新的 token 存储到 localStorage 中
  // ...
  return Promise.resolve();
}

axios.interceptors.response.use(
  response => {
    // 在响应返回之前做一些处理
    return response;
  },
  error => {
    // 处理响应错误
    if (error.response && error.response.status === 401) {
      console.error("请求出错：", error.response);
      if (localStorage.getItem("mp_refreshToken")) {
        axios
          .post(`${BASE_HOST}/api/v1/auth/token/refresh`, {
            refreshToken: localStorage.getItem("mp_refreshToken")
          })
          .then(response => {
            console.log("Tokenres", response.data);
            localStorage.setItem(
              "mp_accessToken",
              response.data.data.accessToken
            );
            localStorage.setItem(
              "mp_refreshToken",
              response.data.data.refreshToken
            );
            window.location.reload();
          })
          .catch(refreshError => {
            console.error("刷新 token 出错：", refreshError);
            localStorage.setItem("mp_refreshToken", "");
            localStorage.clear();
            window.location.reload();
          });
      } else {
        localStorage.clear();
        window.location.reload();
      }
    } else {
      console.error("请求出错：", error.message);
    }
    return Promise.reject(error);
  }
);
axios.CancelToken = Axios.CancelToken;
axios.isCancel = Axios.isCancel;
axios.create = Axios.create;

extendAxiosInstance(axios);

export default axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js